import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Unveil} from '@homeaway/react-unveil';

// Some day we should turn this back in to a property carousel
export class PropertyCarousel extends Component {
    static propTypes = {
        image: PropTypes.string,
    };

    static defaultProps = {
        image: 'http://csvcus.homeaway.com/rsrcs/cdn-logos/2.12.0/bce/brand/misc/property-image-placeholder.svg',
    };

    render() {
        return (
            <div className="row visible-xs-block hidden-print">
                <Unveil
                    className="image-with-overlay-container"
                    backgroundImage={this.props.image}
                />
            </div>
        );
    }
}
